import request from '@/utils/request'
const context = require('./context')

export function fetchCityList(params) {
    return request({
        url: context.EEOP + '/city/listAll/' + params,
        method: 'get'
    })
}

export function fetchProvince(params) {
    return request({
        url: context.EEOP + '/city/province/' + params,
        method: 'get'
    })
}

export function fetchGroupList() {
    return request({
        url: context.EEOP + '/city/groupList',
        method: 'get'
    })
}

export function fetchExtAreaGroupList() {
    return request({
        url: context.EEOP + '/city/extAreaList',
        method: 'get'
    })
}

export function areaChangeStus(params) {
    return request({
        url: context.EEOP + '/city/areaChange',
        method: 'post',
        data: params
    })
}

export function fetchAreaList() {
	return request({
		url: context.EEOP + '/city/areaList',
		method: 'get'
	})
}


// WEBPACK FOOTER //
// ./src/api/city.js